import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  fullWidth = false,
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-[#E85D5D] text-white hover:bg-[#d64d4d] hover:shadow-lg focus:ring-[#E85D5D]',
    secondary: 'bg-[#4DBFB8] text-white hover:bg-[#3da8a2] hover:shadow-lg focus:ring-[#4DBFB8]',
    outline: 'border-2 border-[#4DBFB8] text-[#4DBFB8] hover:bg-[#4DBFB8] hover:text-white'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-248">
      {children}
    </motion.button>;
}